export const contentTableConfig = {
  title: '部门列表',
  propList: [
    { prop: 'name', label: '部门名', minWidth: '100', align: 'left' },
    { prop: 'seq', label: '部门排序', minWidth: '80' },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '120',
      slotName: 'createdTime'
    },
    {
      prop: 'updatedTime',
      label: '更新时间',
      minWidth: '120',
      slotName: 'updatedTime'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  childrenProps: {
    rowKey: 'id'
  },
  showFooter: false
}
